import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Reveal, { SectionLabel } from "../components/Reveal";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const [lead, ...rest] = posts;

  return (
    <div data-testid="blog-page">
      <Header />
      <section className="relative overflow-hidden border-b border-line">
        <div className="terminal-grid absolute inset-0 opacity-50" />
        <div className="absolute -left-24 top-0 h-72 w-72 rounded-full bg-signal/15 blur-[130px]" />
        <div className="relative mx-auto max-w-7xl px-5 py-20 lg:px-8">
          <Reveal>
            <SectionLabel>Insights & Analysis</SectionLabel>
            <h1 className="mt-3 font-display text-5xl font-900 tracking-tight text-white sm:text-6xl">
              Prop firm articles <span className="text-gradient">& news</span>
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-muted">
              Methodology breakdowns, head-to-head evaluations and payout intelligence from the
              TerminalEdge desk.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        {loading ? (
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-muted" data-testid="blog-loading">LOADING JOURNAL<span className="animate-blink">…</span></p>
        ) : (
          <div className="grid gap-4 lg:grid-cols-3" data-testid="blog-grid">
            {lead && (
              <Reveal className="lg:col-span-2 lg:row-span-2">
                <Link to={`/blog/${lead.slug}`} className="card-violet group flex h-full flex-col overflow-hidden" data-testid={`blog-lead-${lead.slug}`}>
                  <div className="overflow-hidden">
                    <img src={lead.cover_image} alt="" className="aspect-[16/8] w-full object-cover opacity-80 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100" />
                  </div>
                  <div className="flex flex-1 flex-col p-8 lg:p-10">
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-signal">{lead.category} · {lead.read_time}</p>
                    <h2 className="mt-4 font-display text-3xl font-800 leading-tight tracking-tight text-white transition-colors group-hover:text-signal lg:text-4xl">{lead.title}</h2>
                    <p className="mt-4 max-w-xl text-sm leading-relaxed text-muted lg:text-base">{lead.excerpt}</p>
                    <span className="mt-auto pt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-muted group-hover:text-signal">READ THE FILE →</span>
                  </div>
                </Link>
              </Reveal>
            )}
            {rest.map((p, i) => (
              <Reveal key={p.id} delay={0.08 * (i + 1)}>
                <Link to={`/blog/${p.slug}`} className="card-violet group flex h-full flex-col overflow-hidden" data-testid={`blog-card-${p.slug}`}>
                  <div className="overflow-hidden">
                    <img src={p.cover_image} alt="" className="aspect-[16/9] w-full object-cover opacity-80 transition-all duration-500 group-hover:scale-105 group-hover:opacity-100" />
                  </div>
                  <div className="flex flex-1 flex-col p-7">
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-signal">{p.category} · {p.read_time}</p>
                    <h3 className="mt-3 font-display text-xl font-700 leading-snug tracking-tight text-white transition-colors group-hover:text-signal">{p.title}</h3>
                    <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-muted">{p.excerpt}</p>
                    <span className="mt-auto pt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-muted group-hover:text-signal">READ THE FILE →</span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
